module.exports = __webpack_public_path__ + "10_mole.364bbeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/10_mole.png
// module id = rXy5
// module chunks = 0